/*
 * @Author: your name
 * @Date: 2021-07-20 14:18:36
 * @LastEditTime: 2022-07-14 19:59:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admine:\LBB\front_end_nest_app_project\src\utils\index.js
 */
import router from '@/router'
export default {
    getDistance(lat1, lng1, lat2, lng2) {
        let radLat1 = lat1 * Math.PI / 180.0;
        let radLat2 = lat2 * Math.PI / 180.0;
        let a = radLat1 - radLat2;
        let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
        let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
        s = s * 6378.137
        s = Math.round(s * 10000) / 10000; //公里
        return s.toFixed(1);
    },
    //星星展示一半
    start(number) {
        let vInt = parseInt(number);
        let vfloor = number - vInt;
        if (0 < vfloor && vfloor < 0.5) {
            vfloor = 0
        } else {
            vfloor = 0.5
        }
        return vInt + vfloor
    },
    //去下载
    routerDownload() {
        router.push({ name: 'download' })
    },
    //去注册
    routerRegister(myCode) {
        router.push({ name: 'register', query: { myCode: myCode } })
    },
    //手机号码
    phoneFormat(data) {
        return /^1[3456789]\d{9}$/.test(data);
    },
    //判断是ios还是安卓跳转  eventClickId 28酒店
    appSouzrce(param) {
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
            console.log(`bamarrycall://param?${param}`);
            location.href = `bamarrycall://param?${param}`;
            return "ios";
        } else {
            location.href = `bamarrycall://param?${param}`;
            return "andriod";
        }
    },
    /**
     * @Description: 时间格式化
     * @param {type} fmt  时间格式 yyyy-MM-dd HH:mm:ss/yyyy-MM-dd
     * @param {type} template 时间轴
     * @LastEditDesc:
    */
    formatDate(fmt, template) {
        let date = new Date(template)
        var o = {
            "M+": date.getMonth() + 1,     //月份 
            "d+": date.getDate(),     //日 
            "h+": date.getHours(),     //小时 
            "m+": date.getMinutes(),     //分 
            "s+": date.getSeconds(),     //秒 
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
            "S": date.getMilliseconds()    //毫秒 
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },

    /**
     * @Description: 描述 获取url参数
     * @version: 版本号
     * @Author: 作者
     * @Date: 2022-07-12 11:21:05
     * @param {*} name
     * @return {*}
     * @LastEditTime: Do not Edit
     * @LastEditDesc: 最后一次编辑备注
     */    
     getQueryString(name) {
        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        const search = decodeURI((window.location.search || window.location.hash)).split('?')[1] || '';
        const r = search.match(reg) || [];
        return r[2];
    }

}



// WEBPACK FOOTER //
// ./src/utils/index.js